// src/Gb.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Gb_default = createIcon({
  displayName: "Gb",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "blue dark",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 1V33H49.5V1H1.5Z",
        fill: "#0070B8"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "white",
        d: "M6.90833 1L49.5 29.3944V33H44.0917L1.5 4.60555L1.5 1L6.90833 1Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "white_2",
        d: "M6.90833 33L49.5 4.60555V1L44.0917 1L1.5 29.3944L1.5 33H6.90833Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx("path", { id: "red", d: "M1.5 1V3.4037L21.8944 17H25.5L1.5 1Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_2", d: "M25.5 17V14.5963L45.8944 1H49.5L25.5 17Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_3", d: "M49.5 33V30.5963L29.1056 17H25.5L49.5 33Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_4", d: "M1.5 33L25.5 17V19.4037L5.10555 33H1.5Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "white cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.5 1H20.5V12H1.5V22H20.5V33H30.5V22H49.5V12H30.5V1Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "red cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.5 1H22.5V14H1.5V20H22.5V33H28.5V20H49.5V14H28.5V1Z",
        fill: "#FF1A26"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});

export {
  Gb_default
};
